// extracted by mini-css-extract-plugin
export default {"avatar":"HeaderDesktopMenu_avatar__cn5xI"};